export class EditEmployeeModel {
    constructor(
        public BirthDate?: string,
        public FAntiguedad?: string,
        public FFinContrato?: string,
        public Position?: string,
        public Telephone1?: string,
        public Telephone2?: string,
        public Movil?: string,
        public Telephone4?: string,
        public Direction1?: string,
        public Province1?: string,
        public City1?: string,
        public PostalCode1?: string,
        public Direction2?: string,
        public Province2?: string,
        public City2?: string,
        public PostalCode2?: string,
        public ObsDireccion?: string,
        public Observation?: string,
        public Nif?: string,
        public Sexo?: string,
        public Apellidos?: string,
        public Nombre?: string,
        public Atributo1?: string,
        public Atributo2?: string,
        public Atributo3?: string,
        public Atributo4?: string,
        public Atributo5?: string,
        public Atributo6?: string,
        public Atributo7?: string,
        public Atributo8?: string,
        public Atributo9?: string,
        public Atributo10?: string,
        public Atributo11?: string,
        public Atributo12?: string,
        public TipoConsentimiento?: string,
        public Consentimiento?: string,
        public RefTrabajador?:string,
        public PuestoUrgente?:string,
        public TelCancelado?:string
    ) {}
}
